import React, { act, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './RightSlider.module.scss';
import modalExit from '../../../assets/icons/vector/exitModalIcon.svg';
import { useBrandingContext } from 'app-context/BrandingsContext';

const RightSlider = ({
  action,
  children,
  icon,
  title,
  actionButtons,
  className,
  titleClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;

  const toggleMenu = () => {
    if (action) {
      action.setIsOpen(!action.isOpen);
    } else {
      setIsOpen(!isOpen);
    }
  };

  const isMenuOpen = action?.isOpen || isOpen;

  const modalContent = (
    <>
      <div
        className={`${styles.backdrop} ${isMenuOpen ? styles.open : ''}`}
        onClick={toggleMenu}
        style={{
          color: page_TextColor,
        }}
      ></div>
      <div
        className={`${styles['menu-container']} ${
          isMenuOpen ? styles.open : ''
        } ${className}`}
        style={{
          color: page_TextColor,
        }}
      >
        {action.isOpen ? (
          <>
            <div className={styles.header}>
              <div className={styles.subheader}>
                <h3 className={titleClassName}>{title}</h3>
                <div className={styles['actions-container']}>
                  {actionButtons}
                  <img src={modalExit} alt='Close' onClick={toggleMenu} />
                </div>
              </div>
            </div>

            <div className={styles['content']}>{children}</div>
          </>
        ) : null}
      </div>
    </>
  );

  return (
    <>
      {!action && (
        <div className={`${styles['menu-button']}`} onClick={toggleMenu}>
          <img src={icon} alt='icon' className={styles['burger-icon']} />
        </div>
      )}

      {ReactDOM.createPortal(modalContent, document.body)}
    </>
  );
};

export default RightSlider;
